import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import commonReducer from './commonSlice';
import contentCreateReducer from './contentCreateSlice';
import createProductReducer from './createProductSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    common: commonReducer,
    contentCreate: contentCreateReducer,
    createProduct: createProductReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
